import { tablesRecomputeRows } from './computed-columns'

/**
 * Registry of built-in actions that are automatically included in every agent
 * These actions are defined in the runtime and don't need to be created by users
 */
export const BuiltInActions = {
  tablesRecomputeRows,
}
